<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="name">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="cubeName">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
    </wbo-search-form>
    <wbo-search-grid [disableViewAction]="true">
        <wbo-main-search-column field="name"></wbo-main-search-column>
        <wbo-translated-column field="pageType" prefix="wbo.bi.common"></wbo-translated-column>
        <wbo-column field="cubeName"></wbo-column>
        <wbo-column field="owner"></wbo-column>
    </wbo-search-grid>
</wbo-search-page>
